// TEMPLATE — pending licensed attorney review (insurance + financial services).
// Do not treat the seeded copy as final legal text.
import { createFileRoute } from "@tanstack/react-router";
import { LegalPageLayout } from "@/components/legal/LegalPageLayout";
import { seo } from "@/lib/seo";

export const Route = createFileRoute("/terms")({
  head: () =>
    seo({
      title: "Terms of Service · Currency Thoughts",
      description:
        "The terms that govern your use of the Currency Thoughts website and platform.",
      canonical: "/terms",
    }),
  component: () => (
    <LegalPageLayout
      slug="terms"
      fallbackTitle="Terms of Service"
      fallbackHeadline="The terms of our relationship."
    />
  ),
});